const TeamsTable = props => {
  const data = props.data
  if (data.length < 1) {
    return (
      <div className="no-data">
        No data
      </div>
    )
  }
  const arr = data.reduce((arr, item) => [
    arr[0] + item.total,
    arr[1] + item.success
  ], [0, 0])

  return (
    <table className="table table-striped teams-table">
      <thead>
        <tr>
          <th scope="col">Team</th>
          <th scope="col" className="text-center">Total</th>
          <th scope="col" className="text-center">Win</th>
          <th scope="col" className="text-center">%</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map(item => (
              <tr key={item.id}>
                <td className="fw-bold">{item.name}</td>
                <td className="text-center">{item.total}</td>
                <td className="text-center">{item.success}</td>
                <td className="text-center">{Math.round(1000 * item.success / item.total)/10}</td>
              </tr>
            )
          )
        }
        <tr key="total" className="table-info">
          <td className="fw-bold">Total:</td>
          <td className="text-center">{arr[0]}</td>
          <td className="text-center">{arr[1]}</td>
          <td className="text-center">{Math.round(1000 * arr[1] / arr[0])/10}</td>
        </tr>
      </tbody>
    </table>
  )
}

export default TeamsTable
